/* Gluca buy box: subscribe / one time toggle that drives every bundle card, plus
   save %, price per bottle and plan specific perks. Works alongside elare-motion.js
   (initBundles keeps pricing and the add to cart form in sync) and the sticky bar. */
(function () {
  function init() {
    var wrap = document.querySelector('[data-elare-bundles]');
    var toggle = document.querySelector('[data-gbb-toggle]');
    if (!wrap || !toggle) return;
    var cards = Array.prototype.slice.call(wrap.querySelectorAll('[data-elare-card]'));
    if (!cards.length) return;
    var note = document.querySelector('[data-gbb-note]');
    var offer = document.querySelector('[data-gbb-offer]');
    var giftRow = document.querySelector('[data-gbb-giftrow]');
    var busy = false;

    /* the offer strip above the button mirrors whichever bundle is selected,
       so the price, the saving and the gifts are visible without scrolling */
    function paintOffer(card, plan) {
      if (!offer) return;
      var r = radio(card);
      var p = priceOf(card);
      var was = num(r && r.getAttribute('data-money-was'));
      var bottles = parseInt(card.getAttribute('data-bottles') || '1', 10) || 1;
      var name = card.querySelector('.gbb-name b');
      var supply = card.querySelector('.gbb-name small');
      var pack = offer.querySelector('[data-gbb-offer-pack]');
      if (pack) pack.textContent = [name && name.textContent, supply && supply.textContent].filter(Boolean).join(', ');
      var now = offer.querySelector('[data-gbb-offer-now]');
      if (now) now.textContent = money(p);
      var wasEl = offer.querySelector('[data-gbb-offer-was]');
      if (wasEl) { wasEl.textContent = was ? money(was) : ''; wasEl.hidden = !(was > p); }
      var per = offer.querySelector('[data-gbb-offer-per]');
      if (per) per.textContent = p ? money(p / bottles) + ' / bottle' : '';
      var saveEl = offer.querySelector('[data-gbb-offer-save]');
      if (saveEl) {
        var pct = was > p && p > 0 ? Math.round((1 - p / was) * 100) : 0;
        saveEl.textContent = pct ? 'SAVE ' + pct + '%' : '';
        saveEl.hidden = !pct;
      }
      var planEl = offer.querySelector('[data-gbb-offer-plan]');
      if (planEl) {
        var every = card.querySelector('[data-gbb-every]');
        planEl.textContent = plan === 'sub'
          ? (every && every.textContent ? every.textContent + '. Skip or cancel anytime.' : 'Subscription. Skip or cancel anytime.')
          : 'One-time purchase, no subscription.';
      }
      if (giftRow) giftRow.hidden = bottles < 2;
    }

    function num(s) {
      var m = String(s || '').replace(/,/g, '').match(/[0-9]+(?:\.[0-9]+)?/);
      return m ? parseFloat(m[0]) : 0;
    }
    function money(n) { return '$' + n.toFixed(2); }
    function radio(c) { return c.querySelector('[data-elare-opt]'); }
    function planOf(c) { return c.getAttribute('data-plan') === 'sub' ? 'sub' : 'onetime'; }
    function selected() { return cards.filter(function (c) { var r = radio(c); return r && r.checked; })[0] || cards[0]; }
    function priceOf(c, plan) {
      var r = radio(c);
      if (!r) return 0;
      var one = num(r.getAttribute('data-money-one'));
      var sub = num(r.getAttribute('data-money-sub'));
      return (plan || planOf(c)) === 'sub' && sub ? sub : one;
    }

    function paint() {
      var plan = planOf(selected());
      paintOffer(selected(), plan);
      Array.prototype.forEach.call(toggle.querySelectorAll('[data-gbb-plan]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-gbb-plan') === plan ? 'true' : 'false');
      });
      if (note) note.textContent = note.getAttribute(plan === 'sub' ? 'data-sub' : 'data-one') || '';
      cards.forEach(function (c) {
        var r = radio(c);
        var p = priceOf(c);
        var was = num(r && r.getAttribute('data-money-was'));
        var bottles = parseInt(c.getAttribute('data-bottles') || '1', 10) || 1;
        var save = c.querySelector('[data-gbb-save]');
        if (save) {
          var pct = was > p && p > 0 ? Math.round((1 - p / was) * 100) : 0;
          save.textContent = pct ? 'SAVE ' + pct + '%' : '';
          save.hidden = !pct;
        }
        var per = c.querySelector('[data-gbb-per]');
        if (per) per.textContent = p ? money(p / bottles) + ' / bottle' : '';
        var every = c.querySelector('[data-gbb-every]');
        if (every) every.hidden = planOf(c) !== 'sub';
        Array.prototype.forEach.call(c.querySelectorAll('[data-gbb-subonly]'), function (li) { li.hidden = planOf(c) !== 'sub'; });
        /* shipping is free on every order, so this perk always shows */
        Array.prototype.forEach.call(c.querySelectorAll('[data-gbb-freeship]'), function (li) { li.hidden = false; });
      });
    }

    function setPlan(plan) {
      busy = true;
      cards.forEach(function (c) { c.setAttribute('data-plan', plan); });
      var r = radio(selected());
      if (r) r.dispatchEvent(new Event('change', { bubbles: true }));
      busy = false;
      paint();
    }

    toggle.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gbb-plan]');
      if (!b) return;
      setPlan(b.getAttribute('data-gbb-plan') === 'sub' ? 'sub' : 'onetime');
    });

    /* keep every card on the same plan when something else (like the sticky bar) changes one card */
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (list) {
        if (busy) return;
        for (var i = 0; i < list.length; i++) {
          var c = list[i].target;
          if (list[i].attributeName === 'data-plan') {
            var plan = planOf(c);
            if (cards.some(function (x) { return planOf(x) !== plan; })) { setPlan(plan); return; }
          }
        }
        paint();
      });
      cards.forEach(function (c) { mo.observe(c, { attributes: true, attributeFilter: ['data-plan', 'class'] }); });
    }
    wrap.addEventListener('change', function () { setTimeout(paint, 0); });

    /* start every card on the plan of the default selected card */
    setPlan(planOf(selected()));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Per-bundle add to cart (all screens): select that bundle, then run the main button so the
   cart drawer, gifts and subscription plan behave exactly as they do from the top button. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gbb-card-atc]');
    if (!btn || btn.hasAttribute('data-busy')) return;
    e.preventDefault();
    var card = btn.previousElementSibling;
    if (!card || !card.hasAttribute('data-elare-card')) return;
    var radio = card.querySelector('input[data-elare-opt]');
    if (radio && !radio.checked) radio.click();
    btn.setAttribute('data-busy', '');
    /* give the buy box a moment to sync the form's variant and selling plan */
    setTimeout(function () {
      var main = document.querySelector('.elare-info button.elare-atc');
      if (main) main.click();
      setTimeout(function () { btn.removeAttribute('data-busy'); }, 1200);
    }, 150);
  });
})();
